module.exports = __webpack_public_path__ + "cathedral.jpg?c19325677f6500cb999c57b714c9dcd5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/cathedral.jpg
// module id = 108
// module chunks = 0